import router from './router'

// 监听路由跳转，如果有参数着带入下一个路由
router.beforeEach(async (to, from, next) => {
  if (to.query.gameId&&to.query.aid) {
    next();
    return;
  }
  if (from.query.gameId&&from.query.aid) {
    let toQuery = JSON.parse(JSON.stringify(to.query));
    toQuery.gameId = from.query.gameId;
    toQuery.aid = from.query.aid;
    next({
      path: to.path,
      query: toQuery
    })
  } else {
    let toQuery = JSON.parse(JSON.stringify(to.query));
    // toQuery.gameId = '0';
    // toQuery.aid = '0';
    toQuery.gameId = '16243';
    // toQuery.gameId = '14997';
    toQuery.aid = '4314439';
    // toQuery.aid = '4024966';
    next({
      path: to.path,
      query: toQuery
    })
  }
})
